import { SiteGatewayZonePricingPlan } from 'src/features/pricing/sites/utils/types';

export type AdministrativeTranslation = {
    id: string;
    created_at: string;
    modified_at: string;
    language: string;
    name: string;
    description: string;
};

export enum ZONE_TYPE {
    REGULAR = 'regular',
    VIP = 'vip',
    DISABLED = 'disabled',
    EV = 'ev',
    MOTORCYCLE = 'motorcycle',
    BUFFER = 'buffer',
}

export enum ZONE_CAPACITY_TYPE {
    CLIENT = 'client',
    VIP = 'vip',
    RESIDENT = 'resident',
    STAFF = 'staff',
    SERVICE = 'service',
    RESERVATION = 'reservation',
}

export enum VISITOR_CATEGORY_TYPE {
    CLIENT = 'client',
    VIP = 'vip',
    RESIDENT = 'resident',
    STAFF = 'staff',
    SERVICE = 'service',
    SUBSCRIPTION = 'subscription',
    RESERVATION = 'reservation',
}

type SiteTranslation = {
    id: string;
    created_at: string;
    modified_at: string;
    language: string;
    name: string;
    address: string;
    city: string;
};

export type Zone = {
    id: string;
    translations: AdministrativeTranslation[];
    capacity_limits: {
        id: string;
        created_at: string;
        modified_at: string;
        visitor_categories: ZONE_CAPACITY_TYPE[];
        spaces_count: number;
    }[];
    visitor_categories: VISITOR_CATEGORY_TYPE[];
    created_at: string;
    modified_at: string;
    type: ZONE_TYPE;
    total_spaces: number;
    spaces_count: number;
    overflow_spaces: number;
    limit_access_per_capacity: boolean;
    limit_user_access: boolean;
    allow_unknown_main_identifier: boolean;
    site: {
        id: string;
        translations: SiteTranslation[];
    };
    service_provider: {
        id: string;
        name: string;
    };
    parent_zone: {
        id: string;
        translations: AdministrativeTranslation[];
    };
    user_access: { id: string; name: string }[];
};

export interface ZonePricingPlan extends SiteGatewayZonePricingPlan {
    zone?: string;
    zone_translations?: {
        language: string;
        name: string;
    }[];
}